import React, { useState, useRef, useEffect } from 'react';
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/WAY-TRIX.png';

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const drawerRef = useRef(null);
  const navigate = useNavigate();
  const [waytrixToken, setWaytrixToken] = useState(localStorage.getItem('waytrixToken') || '');

  useEffect(() => {
    const handleStorageChange = () => {
      setWaytrixToken(localStorage.getItem('waytrixToken') || '');
    };
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('waytrixTokenChange', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('waytrixTokenChange', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleMenuItemClick = (event) => {
    event.currentTarget.querySelector('.sub-menu').classList.toggle('show');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={logo} alt="Waytrix Logo" style={{ height: '50px', marginTop: '15px' }} />
        </Link>
        <div className="navbar-toggle" onClick={toggleDrawer}>
          <div className={`hamburger ${drawerOpen ? 'open' : ''}`}>
            <div className="linee" style={{ width: '100%' }}></div>
            <div className="linee" style={{ width: '100%' }}></div>
            <div className="linee" style={{ width: '100%' }}></div>
          </div>
        </div>
        <div ref={drawerRef} className={`drawer ${drawerOpen ? 'open' : ''}`}>
          <ul className="drawer-menu">
            <Link className='Link' to="/">
              <li className="drawer-menu-item">
                <span className="dropdown-toggle aTitle">Waytrix Dashboard</span>
              </li>
            </Link>
            {!waytrixToken &&
              <Link className='Link' to="/WaytrixLogin">
                <li className="drawer-menu-item">
                  <span className="dropdown-toggle aTitle">Waytrix Login</span>
                </li>
              </Link>
            }
            {waytrixToken &&
              <li className="drawer-menu-item">
                <span className="dropdown-toggle aTitle" onClick={() => { localStorage.removeItem('waytrixToken'); setWaytrixToken(''); window.dispatchEvent(new CustomEvent('waytrixTokenChange')); navigate('/'); }}>
                  Waytrix Logout
                </span>
              </li>
            }
            {waytrixToken &&
              <li className="drawer-menu-item" onClick={handleMenuItemClick}>
                <span className="dropdown-toggle aTitle">Waytrix Account</span>
                <ul className="sub-menu">
                  <li className='aSubTitle'><Link className='Link' to="/NavResto">Resto</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/AddResto">Add Resto</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/AddPartners">Add Partners</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/AddVoucher">Add Voucher</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/GetAllRestoForVidPrev">Video Preview</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/popup-forms">Popup Forms</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/SurveyConfig">Custom Surveys</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/multiple-videos">Multiple Videos</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/spin-analytics">Spin Analytics</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/WorldCup">World Cup 2026</Link></li>
                  <li className='aSubTitle'><Link className='Link' to="/GetRestoAccountForDelete">Delete Resto</Link></li>
                </ul>
              </li>
            }
            <a className='Link' href="https://resto.way-trix.com/RestoLogin" target="_blank" rel="noopener noreferrer">
              <li className="drawer-menu-item">
                <span className="dropdown-toggle aTitle">Resto Login</span>
              </li>
            </a>
            <a className='Link' href="https://partner.way-trix.com/PartnerLogin" target="_blank" rel="noopener noreferrer">
              <li className="drawer-menu-item">
                <span className="dropdown-toggle aTitle">Partner Login</span>
              </li>
            </a>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
